module.exports = __webpack_public_path__ + "img/moon-02.94b6055e.svg";